import { useContext, useEffect } from "react";
import { titleFromParams } from "../../Utilities/helperFunction";
import appContext from "../../appContext";
import "./style.scss";

const GoogleLogin = ({
  mock,
  index,
  setValue,
  setMaintainValues,
  maintainValues,
}) => {
  const { setCustomStyles, googleDetails } = useContext(appContext);

  useEffect(() => {
    setCustomStyles(mock?.styles || {});
  }, []);

  useEffect(() => {
    if (Object.keys(googleDetails || {}).length) {
      setValue(mock?.name, googleDetails);
      setMaintainValues({
        ...maintainValues,
        [`${mock?.name}`]: googleDetails,
      });
    }
  }, [googleDetails]);

  return (
    <div className="google-container">
      <div className="google-title">
        <h1 className="title">
          <span>
            {index}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="11"
              height="10"
              viewBox="0 0 24 24"
            >
              <path d="M13.025 1l-2.847 2.828 6.176 6.176h-16.354v3.992h16.354l-6.176 6.176 2.847 2.828 10.975-11z" />
            </svg>
          </span>
          <div
            dangerouslySetInnerHTML={{ __html: titleFromParams(mock?.title) }}
          />
        </h1>
        <div
          className="description-container"
          dangerouslySetInnerHTML={{ __html: mock?.description }}
        />
      </div>
      <iframe
        title="Executive summary Google Login"
        frameborder="0"
        height="50px"
        src={`${process.env.REACT_APP_GOOGLE_LOGIN_URL}?isBackground=false`}
      ></iframe>
    </div>
  );
};

export default GoogleLogin;
